import {connect} from '@gisatcz/ptr-state';
import Select from '../../../../../../state/Select';
import Action from '../../../../../../state/Action';
import Presentation from './presentation';

const mapStateToProps = state => {
	return {
		availableLayers: Select.insar.getAvailableBackgroundLayers(state),
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onLayerChange: key => {
			dispatch(Action.insar.setBackgroundLayer(key));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
